import React, { ReactElement } from "react";
import { useTranslation } from "next-i18next";
import QRCode from "react-qr-code";
import { trackEvent } from "@kunduz/utility-analytics";
import { copyToClipboard } from "../../services/utilityService";
import styles from "./questionSideCta.module.scss";
import { Arrow, GiftIcon } from "./referFriendPaidCta";
import { useStudentLimits } from "@kunduz/data-access-core-api";
import { QuestionIndexing } from "@kunduz/data-access-qi-api";
import { useAppContext } from "@kunduz/feature-website-context";
import { Button, Text } from "@kunduz/ui-atoms";
import { Copy01, Link01 } from "@untitled-ui/icons-react";

const ReferFriendFreeCta = (props: Props): ReactElement => {
  const { t } = useTranslation("questionIndexing");
  const { student, kunduzApiToken } = useAppContext();
  const { studentLimits } = useStudentLimits(kunduzApiToken);

  function copyReferralCode(e) {
    e.preventDefault();
    copyToClipboard(student.data?.referral_code?.code);
    trackCopyClick();
  }

  function copyLink(e) {
    e.preventDefault();
    copyToClipboard(student.data?.referral_code?.shareable_link);
    trackCopyClick();
  }

  function trackCopyClick() {
    const plan_type = !student.data?.primary_package
      ? "freemium"
      : student.data?.primary_package?.package.is_recurring
        ? "monthly"
        : "unlimited";

    trackEvent("Question Indexing Referral Information Copied", {
      course: props.question?.course?.slug,
      subject: props.question?.subject?.slug,
      page_slug: window.location.pathname,
      remaining_answer_credit: studentLimits?.questions?.remained,
      initial_answer_credit: studentLimits?.questions?.total,
      plan_type,
      persona: undefined,
    });
  }

  return (
    <div className={styles.referFriendCta}>
      <GiftIcon />
      <div
        className={styles.title}
        dangerouslySetInnerHTML={{
          __html: t(
            "question_indexing_sidebar_component_referral_freemium_state_primary_proposition_text",
            {
              reward:
                student.data?.referral_code?.referral_campaign?.owner_question,
            },
          ),
        }}
      ></div>

      <p className={styles.desc}>
        {t(
          "question_indexing_sidebar_component_referral_freemium_state_secondary_proposition_text",
          {
            reward:
              student.data?.referral_code?.referral_campaign
                ?.owner_discount_value,
          },
        )}
      </p>

      <div className={styles.qrLine}>
        <div className={styles.qrWrapper}>
          <QRCode value={student.data?.referral_code?.code || ""} size={106} />
        </div>
        <Arrow className={styles.stupidArrow} />
        <span>
          {t(
            "question_indexing_sidebar_component_referral_freemium_state_arrow_text",
          )}
        </span>
      </div>

      <div className={styles.buttonWrapper}>
        <Button
          variant="secondary"
          color="gray"
          size="xl"
          onClick={copyReferralCode}
        >
          <Copy01 />
          <Text variant="textmd" weight="semibold">
            {student.data?.referral_code?.code}
          </Text>
        </Button>

        <Button
          variant="secondary"
          color="gray"
          size="xl"
          onClick={copyReferralCode}
        >
          <Link01 />
          <Text variant="textmd" weight="semibold">
            {t(
              "question_indexing_sidebar_component_referral_state_copylink_cta_label",
            )}
          </Text>
        </Button>
      </div>
    </div>
  );
};

interface Props {
  question?: QuestionIndexing.TrQiQuestion;
}

export default ReferFriendFreeCta;
